module.exports = __webpack_public_path__ + "img/stripe.ce66cd45.png";